const ufeApi = require('services/api/ufeApi');
const { userXTimestampHeader } = require('utils/Headers');

function acknowledgeGameCompletion(token, { gameId, loyaltyId }) {
    const sdnDomain = Sephora.configurationSettings.sdnDomainBaseUrl;
    const url = `${sdnDomain}/v1/game/${gameId}/user/${loyaltyId}/completion/acknowledge`;
    const timeStamp = userXTimestampHeader()['x-timestamp'];

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            headers: {
                'x-source': 'rwd',
                'X-Request-Timestamp': timeStamp,
                authorization: `Bearer ${token}`
            }
        })
        .then(data => data);
}

module.exports = { acknowledgeGameCompletion };
